<template>
  <notification-base>
    <template #icon_start>
      <warning-icon class="w-6 h-6 text-[var(--info-color)]" />
    </template>
    <template #content>
      <slot name="content">
        <div class="text-th-light-gray font-light text-sm tracking-wide">
          <slot name="content_upper_row" />
        </div>
        <div class="text-th-info-yellow">
          <slot name="content_lower_row" />
        </div>
      </slot>
      <div v-if="routeToOptions" class="mt-2">
        <router-link
          :to="routeToOptions.to"
          class="text-sm"
          @click.stop="routeToOptions.onClick"
          v-text="routeToOptions.text"
        />
      </div>
    </template>
  </notification-base>
</template>

<script>
import NotificationBase from '../base'
import { WarningIcon } from '@shared/assets/icons'
export default {
  components: {
    NotificationBase,
    WarningIcon
  },
  props: {
    routeToOptions: {
      type: Object,
      default: null
    }
  }
}
</script>
